export const GETConfig = (accessToken: string) => {
	const headers = {
		Authorization: `Bearer ${accessToken}`,
		"Content-Type": "application/json",
	};
	return {
		headers: headers,
	};
};

export const POSTConfig = (accessToken: string) => {
	const headers = {
		Authorization: `Bearer ${accessToken}`,
		"Content-Type": "multipart/form-data",
	};
	return {
		headers: headers,
	};
};
